var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Title',{attrs:{"title":"Gestión de Transportes","subtitle":"Lista de patentes"}}),_c('el-row',{attrs:{"gutter":30}},[_c('el-col',[_c('search-vehicles',{on:{"search":_vm.search}}),_c('vehicle-list',{ref:"list"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }